export default __webpack_public_path__ + "static/media/header_logo.1f0a0845.png";